import { render, staticRenderFns } from "./ColectiiAPL.vue?vue&type=template&id=77b6fa6e"
import script from "./ColectiiAPL.vue?vue&type=script&lang=js"
export * from "./ColectiiAPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports